(function () {
  var SHOP = window.Shopify || {};
  var CURRENCY = (SHOP.currency && SHOP.currency.active) || 'EUR';
  var LOCALE = document.documentElement.lang || (navigator && navigator.language) || 'fr-FR';

  function fetchJson(url, opts) {
    opts = opts || {};
    return fetch(url, opts).then(function (r) {
      if (!r.ok) {
        var err = new Error(url + ' → ' + r.status);
        err.status = r.status;
        throw err;
      }
      return r.json();
    });
  }

  function uniq(arr) {
    var seen = Object.create(null);
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var k = String(arr[i]);
      if (k && !seen[k]) {
        seen[k] = true;
        out.push(arr[i]);
      }
    }
    return out;
  }

  function getCart(opts) {
    return fetchJson('/cart.js', Object.assign({ credentials: 'same-origin', cache: 'no-store' }, opts || {}));
  }

  function productJson(handle, opts) {
    return fetchJson('/products/' + encodeURIComponent(handle) + '.js', Object.assign({ credentials: 'same-origin' }, opts || {}));
  }

  function salesOffers(productId, opts) {
    opts = opts || {};
    return getCart().then(function (cart) {
      var qs = new URLSearchParams({
        stage: 'sales',
        products: String(productId),
        cart: cart.token || '',
        currency: cart.currency || activeCurrency(),
        country: (window.Shopify && Shopify.country) || ''
      });
      return fetchJson('/apps/mgm/offer?' + qs.toString(), { signal: opts.signal, credentials: 'same-origin', cache: 'no-store' });
    }).then(function (data) {
      try {
        if (data && data.shipping) {
          window.MGM_SHIPPING = data.shipping;
          document.dispatchEvent(new CustomEvent('mgm:shipping', { detail: data.shipping }));
        }
      } catch (e) {}
      return (data && data.offers) || [];
    });
  }

  function activeCurrency() {
    var SHOP_NOW = window.Shopify || {};
    return (SHOP_NOW.currency && SHOP_NOW.currency.active) || CURRENCY;
  }

  function drawerPayload(opts) {
    opts = opts || {};
    var cartPromise = opts.cart ? Promise.resolve(opts.cart) : getCart({ signal: opts.signal });
    return cartPromise.then(function (cart) {
      var contextProducts = opts.contextProducts || [];
      var productIds = uniq((cart.items || []).map(function (i) { return i.product_id; }).concat(contextProducts));
      var variantIds = uniq((cart.items || []).map(function (i) { return i.variant_id; }));
      var qs = new URLSearchParams({
        cart: cart.token || '',
        products: productIds.join(','),
        variants: variantIds.join(','),
        total: ((cart.total_price || 0) / 100).toString(),
        currency: cart.currency || activeCurrency(),
        country: (window.Shopify && Shopify.country) || ''
      });
      return fetchJson('/apps/mgm/drawer?' + qs.toString(), { signal: opts.signal, credentials: 'same-origin', cache: 'no-store' })
        .then(function (drawer) { return { drawer: drawer, cart: cart }; });
    });
  }

  function event(cartToken, offer, stage, eventName, value) {
    if (!cartToken || !offer) return Promise.resolve();
    return fetch('/apps/mgm/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        cart: cartToken,
        offer_id: offer.offer_id,
        stage: stage,
        event: eventName,
        discount_pct: offer.discount_pct || 0,
        value: value || 0
      })
    }).catch(function () {});
  }

  function addUpsell(offer, stage) {
    return fetchJson('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(offer.variant_id),
          quantity: 1,
          properties: {
            _mgm_stage: stage,
            _mgm_offer: String(offer.offer_id)
          }
        }]
      })
    });
  }

  function changeLine(lineKey, quantity, opts) {
    opts = opts || {};
    return fetchJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
      signal: opts.signal
    });
  }

  function formatPrice(value, currency) {
    if (value === null || value === undefined || isNaN(value)) return '';
    var c = currency || CURRENCY;
    try {
      return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: c }).format(value);
    } catch (e) {
      return Number(value).toFixed(2) + ' ' + c;
    }
  }

  function template(str, vars) {
    if (!str) return '';
    return String(str).replace(/\{(\w+)\}/g, function (_, k) {
      return vars && vars[k] !== undefined ? vars[k] : '{' + k + '}';
    });
  }

  window.MGMFunnel = {
    cart: getCart,
    product: productJson,
    salesOffers: salesOffers,
    drawer: drawerPayload,
    event: event,
    addUpsell: addUpsell,
    changeLine: changeLine,
    formatPrice: formatPrice,
    template: template,
    currency: CURRENCY,
    locale: LOCALE
  };
})();
